import { Controller } from "@hotwired/stimulus"
import SimpleBar from "simplebar"
import Waves from "node-waves"

// Wiring of the Skote admin layout (layouts/admin), ported from KoPilot's
// application.js: ripple effect on .waves-effect, custom scrollbars on
// [data-simplebar], and the topbar button that collapses the sidebar.
export default class extends Controller {
  connect() {
    Waves.init()
    this.element.querySelectorAll("[data-simplebar]").forEach((el) => {
      if (!el.SimpleBar) new SimpleBar(el)
    })
  }

  // Desktop: icon-only sidebar. Below 992px: slide the sidebar in/out.
  toggleMenu(event) {
    event.preventDefault()
    document.body.classList.toggle("sidebar-enable")
    if (window.innerWidth >= 992) {
      document.body.classList.toggle("vertical-collpsed")
    } else {
      document.body.classList.remove("vertical-collpsed")
    }
  }
}
